import angular from 'angular';
import EmailNotificationsTemplateUpdateComponent, {
  EmailNotificationsTemplateUpdateController,
} from 'email-notification-templates/components/update/email-notification-template-update-component';
import template from './sms-notification-edit.html';
import dialogTemplate from './sms-dialog.html';

const UNLIMITED = -1;
const SMS_TEMPLATE_KEY = 'smsTemplate';
const mapStateToThis = ({ session }) => {
  const { locale } = session;

  return {
    locale,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$rootScope', '$state', 'gettextCatalog', 'Notifications')
class SmsNotificationEditController extends EmailNotificationsTemplateUpdateController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
    this.activeTabId = 'sms';
  }

  $onInit() {
    super.$onInit(SMS_TEMPLATE_KEY);
    this.onLanguageSelect(this.locale);
  }

  submitForm() {
    this.api.validateForm.run(this.namespace, this.moduleName).then((model) => {
      if (!this.formModel[this.model.notificationTemplates.smsTemplate.language].smsTemplateBodyTxt) {
        this.Notifications.showComplexDialog({
          dialogTemplate,
        }).then(() =>
          this.api.updateTemplate
            .run(this.templateId)
            .then(() => this.Notifications.alertSuccess(this.gettextCatalog.getString('Template saved successfully')).result)
            .then(() =>
              this.$state.go('emailNotificationsTemplates-view', {
                tabId: this.activeTabId,
                skipDirtyForms: true,
              })
            )
        );
      } else {
        this.api.updateTemplate
          .run(this.templateId)
          .then(() => this.Notifications.alertSuccess(this.gettextCatalog.getString('Template saved successfully')).result)
          .then(() =>
            this.$state.go('emailNotificationsTemplates-view', {
              tabId: this.activeTabId,
              skipDirtyForms: true,
            })
          );
      }
    });
  }

  prepareOptions() {
    return {
      ...this.api.config.ckeditor,
      extraPlugins: 'autogrow,emailVariables,wordcount',
      removePlugins: 'elementspath,save,font',
      emailVariables: this.model.notificationTemplates.smsTemplate.params,
      toolbar: [{ name: 'insert', items: ['emailVariables'] }],
      wordcount: {
        showParagraphs: false,
        showWordCount: false,
        showCharCount: true,
        countSpacesAsChars: true,
        countHTML: true,
        maxWordCount: UNLIMITED,
        maxCharCount: UNLIMITED,
      },
    };
  }

  onLanguageSelect(locale) {
    this.model[this.namespace][this.moduleName].language = locale;
  }
}

class SmsNotificationEditComponent extends EmailNotificationsTemplateUpdateComponent {
  constructor() {
    super();
    this.template = template;
    this.controller = SmsNotificationEditController;
    return this;
  }
}

export default angular.module('sms-notifications-edit', []).component('smsNotificationEdit', new SmsNotificationEditComponent());



// WEBPACK FOOTER //
// ./src/modules/sms/components/sms-notification-templates/components/sms-notification-edit/sms-notification-edit-component.js